import { useCallback, memo } from "react";
import { useHistory, useParams } from "react-router-dom";
import { formatDateTime } from "@app/shared/formatDateTime";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";
import { useVersions } from "@app/provider-network-imports/hooks/useVersions";

function nonMemoProviderNetworkVersionSelect() {
  const { versionId, networkId } = useParams<{ networkId?: string, versionId?: string }>();
  const { versions } = useVersions();
  const history = useHistory();

  const versionChanged = useCallback((id: number) => {
    const path = `/provider-network-import/${networkId}/version/${id}`;
    history.push(path);
  }, []);

  return (
    <QESSelect label="Provider Network Version" hideLabel={true} testId="provider-network-version-select" className="form-control" onChange={(e) => versionChanged(+e.currentTarget.value)} value={+versionId}>
      <option value="" disabled={true}>Select One</option>
      {
        versions.map((version) => {
          return (
            <option key={version.id} value={version.id}>
              {formatDateTime(version.createDate)}
            </option>
          );
        })
      }
    </QESSelect>
  );
}

export const ProviderNetworkVersionSelect = memo(nonMemoProviderNetworkVersionSelect);
